export default "__VITE_ASSET__CQty5jOY__"